import { isMobile } from '../../scripts/helpers';

export default class ContainerResultsSubscriber {
  constructor() {
    var containerImages = document.querySelector('.result-item--featured .result-item__images');

    if(typeof(containerImages) != 'undefined' && containerImages != null) {
      if(!isMobile()) {
        $('.result-item--featured .result-item__images').slick({
          centerMode: true,
          centerPadding: '10px',
          slidesToShow: 1,
          dots: true,
          arrows: true,
          slidesToScroll: 1,
          infinite: false
        });
      }
    }
  }
}

const containerResultsSubscriber = new ContainerResultsSubscriber();